import CustomTooltip from "./CustomTooltip";
import "../CustomSelect.css";

const CustomSelect = ({ title,handleChange,name,data,state, defaultOptionValue, isDisable,tooltipInfo }) => {

    return (
        <>  
            {true ? (<div className="form-floating mb-3">
              <select className="form-select form-select-md capitalize bg-light" aria-label=".form-select-md example" onChange={handleChange(name)}
              value={state?.[name]?.toString()} disabled={isDisable}>
                {/* <option defaultValue>{defaultOptionValue}</option> */}
                <option>{defaultOptionValue}</option>
                {data.map((el,index)=>(
                  <option key={index} value={el.id}>{el.name}</option>
                ))}
              </select>
              {title && <label key={name}>{title} {tooltipInfo ? (<CustomTooltip tooltipInfo={tooltipInfo}/>) : ''}</label>}
            </div>):
            ('')
            }
        </>
    );
}

export default CustomSelect;
